export default "__VITE_ASSET__40347e4b__"